/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { lsolveDependencies } from './dependenciesLsolve.generated';
import { lupDependencies } from './dependenciesLup.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { sluDependencies } from './dependenciesSlu.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { usolveDependencies } from './dependenciesUsolve.generated';
import { createLusolve } from '../../factoriesAny.js';
export var lusolveDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  lsolveDependencies: lsolveDependencies,
  lupDependencies: lupDependencies,
  matrixDependencies: matrixDependencies,
  sluDependencies: sluDependencies,
  typedDependencies: typedDependencies,
  usolveDependencies: usolveDependencies,
  createLusolve: createLusolve
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLusolve.generated.js
// module id = 1446
// module chunks = 0